import { LoginContainer } from './components/Login';
import Logout from './components/Logout';
import Reset from './components/Reset';
import { AlarmsContainer } from './components/Alarms';
import { MetricsContainer } from './components/Metrics';
import { OverviewContainer } from './components/Overview';
// import Report from './components/Report';
import { SettingsContainer } from './components/Settings';
import { SetProfileContainer } from './components/SetProfile';

import {
  PAGE_LOGIN, LOGOUT, RESET, PAGE_OVERVIEW, PAGE_METRICS, PAGE_ALARMS, PAGE_SETTINGS,
  PAGE_SETTINGS_TAB, SET_PROFILE,
} from './utils/types';

export const routes = [
  {
    exact: true,
    path: '/',
    componentToRender: OverviewContainer,
    id: 'base',
    authRequired: true,
    access: 'all',
  },
  {
    path: PAGE_LOGIN,
    componentToRender: LoginContainer,
    id: 'login',
    authRequired: false,
    exact: true,
    access: 'all',
    noSidebar: true,
    init: false,
  },
  {
    path: LOGOUT,
    componentToRender: Logout,
    id: 'logout',
    authRequired: false,
    exact: true,
    access: 'all',
    noSidebar: true,
    init: false,
  },
  {
    path: PAGE_OVERVIEW,
    componentToRender: OverviewContainer,
    id: 'overview',
    authRequired: true,
    access: 'all',
  },
  {
    path: PAGE_METRICS,
    componentToRender: MetricsContainer,
    id: 'metrics',
    authRequired: true,
    access: 'all',
  },
  {
    path: PAGE_ALARMS,
    componentToRender: AlarmsContainer,
    id: 'alarms',
    authRequired: true,
    access: 'all',
  },
  /*
  {
    path: PAGE_REPORT,
    componentToRender: Report,
    id: 'report',
    authRequired: true,
    access: 'all',
  },
  */
  {
    path: PAGE_SETTINGS,
    componentToRender: SettingsContainer,
    id: 'settings',
    authRequired: true,
    exact: true,
    access: 'all',
  },
  {
    path: PAGE_SETTINGS_TAB,
    componentToRender: SettingsContainer,
    id: 'settings/:tab',
    authRequired: true,
    access: 'all',
  },
  {
    path: RESET,
    componentToRender: Reset,
    id: 'reset',
    authRequired: true,
    access: 'all',
  },
  {
    path: SET_PROFILE,
    componentToRender: SetProfileContainer,
    id: 'setProfile',
    authRequired: true,
    access: 'all',
    noSidebar: true,
    init: false,
  },
];



// WEBPACK FOOTER //
// ./src/routes.js